var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPainScore6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.523,
    height: 80.525,
    viewBox: "0 0 80.523 80.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-painscore6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3567",
    "data-name": "Path 3567",
    d: "M361.818-30.237A39.261,39.261,0,0,1,322.556,9.025a39.261,39.261,0,0,1-39.261-39.262A39.261,39.261,0,0,1,322.556-69.5a39.261,39.261,0,0,1,39.262,39.263",
    transform: "translate(-283.295 69.5)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2-painscore6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3572",
    "data-name": "Path 3572",
    d: "M317.244-43.4a6.763,6.763,0,0,0,6.762,6.763A6.763,6.763,0,0,0,330.77-43.4a6.764,6.764,0,0,0-6.764-6.763,6.764,6.764,0,0,0-6.762,6.763",
    transform: "translate(-317.244 50.16)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3-painscore6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3578",
    "data-name": "Path 3578",
    d: "M318.12-43.4a6.763,6.763,0,0,1-6.763,6.763,6.763,6.763,0,0,1-6.764-6.763,6.764,6.764,0,0,1,6.764-6.763A6.764,6.764,0,0,1,318.12-43.4",
    transform: "translate(-304.592 50.16)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4-painscore6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3650",
    "data-name": "Path 3650",
    d: "M309.853-43.368a2.533,2.533,0,0,0,2.533,2.535,2.535,2.535,0,0,0,2.535-2.535,2.536,2.536,0,0,0-2.535-2.535,2.534,2.534,0,0,0-2.533,2.535",
    transform: "translate(-309.853 45.903)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5-painscore6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3653",
    "data-name": "Path 3653",
    d: "M311.148-43.569a1.037,1.037,0,0,0,1.038,1.037,1.037,1.037,0,0,0,1.037-1.037,1.037,1.037,0,0,0-1.037-1.037,1.037,1.037,0,0,0-1.038,1.037",
    transform: "translate(-311.148 44.605)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6-painscore6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3656",
    "data-name": "Path 3656",
    d: "M319.443-43.835a2.537,2.537,0,0,0,2.534,2.535,2.535,2.535,0,0,0,2.535-2.535,2.535,2.535,0,0,0-2.535-2.535,2.537,2.537,0,0,0-2.534,2.535",
    transform: "translate(-319.443 46.369)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7-painscore6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3659",
    "data-name": "Path 3659",
    d: "M320.741-44.035A1.036,1.036,0,0,0,321.776-43a1.039,1.039,0,0,0,1.039-1.037,1.039,1.039,0,0,0-1.039-1.037,1.036,1.036,0,0,0-1.035,1.037",
    transform: "translate(-320.741 45.071)",
    fill: "#00142e",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pain_6",
    "data-name": "Pain 6",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3737",
    "data-name": "Group 3737",
    transform: "translate(0)",
    clipPath: "url(#clip-path-painscore6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3566",
    "data-name": "Path 3566",
    d: "M282.295-70.5h80.832V10.334H282.295Z",
    transform: "translate(-283.449 69.346)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3739",
    "data-name": "Group 3739",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3569",
    "data-name": "Path 3569",
    d: "M78.523,39.263A39.261,39.261,0,1,1,39.261,0,39.261,39.261,0,0,1,78.523,39.263Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3741",
    "data-name": "Group 3741",
    transform: "translate(39.188 22.325)",
    clipPath: "url(#clip-path-2-painscore6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3571",
    "data-name": "Path 3571",
    d: "M316.244-51.16h15.835v15.835H316.244Z",
    transform: "translate(-317.398 50.006)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3743",
    "data-name": "Group 3743",
    transform: "translate(39.188 22.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3574",
    "data-name": "Path 3574",
    d: "M0,6.763A6.763,6.763,0,1,0,6.762,0,6.763,6.763,0,0,0,0,6.763Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3744",
    "data-name": "Group 3744",
    transform: "translate(41.234 24.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3575",
    "data-name": "Path 3575",
    d: "M10.487,8.389S7.757-.483,0,.021",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3746",
    "data-name": "Group 3746",
    transform: "translate(24.584 22.325)",
    clipPath: "url(#clip-path-3-painscore6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3577",
    "data-name": "Path 3577",
    d: "M303.592-51.16h15.836v15.835H303.592Z",
    transform: "translate(-304.746 50.006)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3748",
    "data-name": "Group 3748",
    transform: "translate(24.584 22.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3580",
    "data-name": "Path 3580",
    d: "M13.528,6.763A6.764,6.764,0,1,1,6.764,0,6.763,6.763,0,0,1,13.528,6.763Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3749",
    "data-name": "Group 3749",
    transform: "translate(25.579 24.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3581",
    "data-name": "Path 3581",
    d: "M0,8.389S2.73-.483,10.486.021",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3802",
    "data-name": "Group 3802",
    transform: "translate(30.657 27.238)",
    clipPath: "url(#clip-path-4-painscore6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3649",
    "data-name": "Path 3649",
    d: "M308.853-46.9h7.376v7.378h-7.376Z",
    transform: "translate(-310.007 45.749)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3804",
    "data-name": "Group 3804",
    transform: "translate(32.152 28.737)",
    clipPath: "url(#clip-path-5-painscore6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3652",
    "data-name": "Path 3652",
    d: "M310.148-45.605h4.383v4.382h-4.383Z",
    transform: "translate(-311.302 44.451)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3806",
    "data-name": "Group 3806",
    transform: "translate(41.727 26.7)",
    clipPath: "url(#clip-path-6-painscore6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3655",
    "data-name": "Path 3655",
    d: "M318.443-47.369h7.377v7.378h-7.377Z",
    transform: "translate(-319.597 46.215)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3808",
    "data-name": "Group 3808",
    transform: "translate(43.225 28.198)",
    clipPath: "url(#clip-path-7-painscore6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3658",
    "data-name": "Path 3658",
    d: "M319.741-46.071h4.383v4.382h-4.383Z",
    transform: "translate(-320.895 44.917)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3834",
    "data-name": "Group 3834",
    transform: "translate(19.139 15.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3693",
    "data-name": "Path 3693",
    d: "M0,7.3S4.429,1.317,16.279,0",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3835",
    "data-name": "Group 3835",
    transform: "translate(45.831 15.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3694",
    "data-name": "Path 3694",
    d: "M0,0A31,31,0,0,1,15.2,8.259",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3836",
    "data-name": "Group 3836",
    transform: "translate(19.259 53.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3695",
    "data-name": "Path 3695",
    d: "M0,4.554S2.393.963,11.131.365,30.4-.713,36.627,4.2",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3837",
    "data-name": "Group 3837",
    transform: "translate(29.386 38.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3696",
    "data-name": "Path 3696",
    d: "M1.843,0S1.006,1.915.288,3.172s0,1.676,1.137,1.615,2.093-1.2,3.77-.3S6.87,5.925,8.845,5.925s4.908-.659,5.807-1.916.418-2.034.418-2.034",
    transform: "translate(0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainScore6);
export default __webpack_public_path__ + "static/media/pain_score_6.7f8bd97b.svg";
export { ForwardRef as ReactComponent };